import React, {Component} from 'react'
import {Panel} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {Form, Errors, actions, Control} from 'react-redux-form'
import {FormGroup, Col, Button, Grid, Row} from 'react-bootstrap'
import {getQuestions} from '../../../actions/about-you'
import RequiredPasswordMaskInput from "../../common/form/elements/required-password-mask-input";
import SecurityQuestionAnswer from '../../common/form/user/security-question-answer-input';
import ArrowButton from '../../common/button-arrow';

class WelcomeForm extends Component {

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    this.props.dispatch(getQuestions());
    this.props.dispatch(actions.change('deep.admin_welcome.invitation_token', this.props.token));
  }

  renderHeader() {
    return (
      <h5 className="text-center mg-bottom-20 mg-top-20">Welcome to the ignite administration portal</h5>
    )
  }

  renderFooter() {
    return (
      <div className="fluid text-right">
        <ArrowButton ghost={false}>Next</ArrowButton>
      </div>
    );
  }

  render() {
    const formFields =
      <Panel header={this.renderHeader()} footer={this.renderFooter()}>
        <Errors show={{touched: true}} model="deep.admin_welcome"/>

        <RequiredPasswordMaskInput
          model=".password"
          label="Password"
          controlId="password"/>

        <RequiredPasswordMaskInput
          model=".password_confirmation"
          label="Confirm password"
          controlId="confirm_password"/>

        <SecurityQuestionAnswer
          questions={this.props.questions.filter(question => question.attributes['list-number'] === 1)}
          questionModel=".security_answers_attributes[0].security_question_id"
          answerModel=".security_answers_attributes[0].answer"
          questionControlId="userSecurityQuestion1"
          answerControlId="userSecurityAnswer1"/>

        <SecurityQuestionAnswer
          questions={this.props.questions.filter(question => question.attributes['list-number'] === 2)}
          questionModel=".security_answers_attributes[1].security_question_id"
          answerModel=".security_answers_attributes[1].answer"
          questionLabel="Security question 2"
          answerLabel="Security answer 2"
          answerPlaceHolder="Security answer 2"
          questionControlId="userSecurityQuestion2"
          answerControlId="userSecurityAnswer2"/>

        <FormGroup controlId="terms_and_conditions">
          <label>
            <Control.checkbox model=".t_cs1" required/>
            I agree to the programme <Link to="/content-pages/terms-conditions" target="_blank">terms & conditions</Link>*
            <Errors show={{touched: true}} model=".t_cs1" className="errors"/>
          </label>
        </FormGroup>

        <FormGroup controlId="privacy_policy">
          <label>
            <Control.checkbox model=".t_cs2" required/>
            I agree to the <Link to="/content-pages/privacy-policy" target="_blank">privacy policy</Link>*
            <Errors show={{touched: true}} model=".t_cs2" className="errors"/>
          </label>
        </FormGroup>

        <Control type="hidden" model=".invitation_token" value={this.props.token}/>
      </Panel>;

    return (
      <Grid className="welcome-container">
        <Row>
          <Col md={6} mdOffset={3}>
            <Form model='deep.admin_welcome' onSubmit={this.props.handleSubmit}>
              <Errors show={{touched: true}} className="errors" model="deep.admin_welcome"/>
              {formFields}
            </Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    welcome: state.deep.welcome,
    questions: state.aboutYou.questions
  };
}

export default connect(mapStateToProps)(WelcomeForm);




// WEBPACK FOOTER //
// ./src/components/admin/welcome/welcome-form.jsx